var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":_vm.pcsLogoUrl,"height":_vm.height || null,"width":_vm.width || null,"max-height":_vm.height ? null : (_vm.smallSize ? 72 : 300),"max-width":_vm.width ? null : (_vm.height ? _vm.height * _vm.aspectRatio : (_vm.smallSize ? 65 : 400)),"contain":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }